"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = __importStar(require("styled-components"));
var loader_1 = require("../loader");
var typography_1 = require("../typography");
var styles_1 = __importStar(require("./styles"));
var types_1 = require("./types");
var Button = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n\n  position: relative;\n\n  ", ";\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n\n  position: relative;\n\n  ", ";\n"])), styles_1.buttonReset, styles_1.linkReset, styles_1.default, styles_1.getButtonSize, function (_a) {
    var loading = _a.loading;
    return (Boolean(loading) ? 'pointer-events: none;' : undefined);
});
var ButtonText = (0, styled_components_1.default)(function (_a) {
    var loading = _a.loading, rest = __rest(_a, ["loading"]);
    return (react_1.default.createElement(typography_1.BodyText, __assign({}, rest, { align: 'center' })));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  line-height: 1;\n  opacity: ", ";\n  word-wrap: break-word;\n"], ["\n  line-height: 1;\n  opacity: ", ";\n  word-wrap: break-word;\n"])), function (props) { return (Boolean(props.loading) ? 0 : 1); });
var LoadingState = (0, styled_components_1.default)(function (_a) {
    var loading = _a.loading, rest = __rest(_a, ["loading"]);
    return (react_1.default.createElement(loader_1.Loader, __assign({}, rest)));
}).attrs(function () { return ({
    size: 4.8, // 12x12 px bubbles
}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: ", ";\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: ", ";\n"])), function (props) { return (Boolean(props.loading) ? 1 : 0); });
var getButtonTextSize = function (theme, size) {
    var typography = theme.typography;
    switch (size) {
        case types_1.ButtonSize.small:
            return [typography.fontSizes.fontSize14];
        default:
            return [typography.fontSizes.fontSize16];
    }
};
var BaseButton = function (_a) {
    var label = _a.label, size = _a.size, loading = _a.loading, ariaLabel = _a.ariaLabel, disabled = _a.disabled, variantStyles = _a.variantStyles, props = __rest(_a, ["label", "size", "loading", "ariaLabel", "disabled", "variantStyles"]);
    var theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(Button, __assign({ as: props.to ? react_router_dom_1.Link : 'button', "aria-live": loading ? 'polite' : 'off', "aria-label": loading ? 'Loading' : ariaLabel, "$loading": loading, disabled: disabled, "aria-disabled": disabled, "$variantStyles": variantStyles, size: size }, props),
        react_1.default.createElement(LoadingState, { color: variantStyles === null || variantStyles === void 0 ? void 0 : variantStyles.textColor, loading: loading }),
        react_1.default.createElement(ButtonText, { color: variantStyles === null || variantStyles === void 0 ? void 0 : variantStyles.textColor, loading: loading, sizes: getButtonTextSize(theme, size), weight: theme.typography.fontWeights.regular }, label)));
};
exports.default = BaseButton;
var templateObject_1, templateObject_2, templateObject_3;
